/*首页功能相关路由*/
const wlwyzt_cockpit = () =>
  import(
    "../../../studio/new_cockpit_box/cockpit_children/wlwyzt_cockpit/wlwyztCockpitBoxMain"
  );
import main from "../../../studio/new_cockpit_box/cockpit_children/wlwyzt_cockpit/wlwyzt_asset/wlwyzt_asset_main";
import wlwyzt_asset_main from "../../../studio/new_cockpit_box/cockpit_children/wlwyzt_cockpit/wlwyzt_asset/index_page_main";
import wlwyzt_asset from "../../../studio/new_cockpit_box/cockpit_children/wlwyzt_cockpit/wlwyzt_asset/wlwyzt_asset";
export default [
  {
    path: "/wlwyzt_cockpit",
    name: "物联网一张图",
    component: wlwyzt_cockpit
  },
  {
    path: "/wlwyzt_asset",
    name: "物联网监测管理",
    component: main,
    redirect: "/wlwyzt/index/asset",
    children: [
      {
        path: "/wlwyzt/index",
        redirect: "/wlwyzt/index/asset",
        name: "首页",
        component: wlwyzt_asset_main,
        children: [
          {
            path: "/wlwyzt/index/asset",
            name: "监测设备管理",
            component: wlwyzt_asset
          }
        ]
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/wlwyzt/wlwyzt_cockpit_page.js